<template>
    <div id="mentions" class="row px-1 px-md-0">
        <LinkFoldUnFold
            button-id="legal-mentions-toggle"
            :button-label="title"
            collapsed-block-id="legal-mentions-content"
            :is-collapsed="false"
            is-large
        >
            <div
                id="legal-mentions-content"
                class="font-size-resp-12"
                :aria-labelledby="'mention-legal'"
            >
                <div
                    v-for="(legalMention, index) in legalMentions"
                    :key="'legal-mention-content-' + index"
                    class="col-12 pb-2"
                >
                    <div v-msh-html="legalMention.text" />
                </div>
            </div>
        </LinkFoldUnFold>
    </div>
</template>

<script lang="ts">

import {PropType} from "vue";
import {LegalMention} from "../models/LegalMention";
import LinkFoldUnFold from "../../common/components/ob1/LinkFoldUnfold.vue";

export default {
    name: "LegalMentions",
    components: {LinkFoldUnFold},
    props: {
        legalMentions: {
            type: Array as PropType<LegalMention[]>,
            required: true
        },
    },
    computed: {
        title(): string {
            const titles: string[] = this.legalMentions
                .map((legalMention: LegalMention): string => legalMention.title)
                .filter((legalMentionTitle: string): boolean => !!legalMentionTitle);

            if (titles.length === 0) {
                return "Conditions";
            }

            return titles.join(" et ");
        }
    }
}
</script>
